export default __webpack_public_path__ + "static/media/About_BG-Shapes-02 1.a6444347.png";